<template>
  <div>
    <v-text-field
      v-model="value.identifier"
      :label="$t('dangerousGoods.dangerousGoodsList.form.identifier')"
      :rules="rules"
      data-cy="identifier"
    ></v-text-field>
  </div>
</template>
<script>
export default {
  props: ["value"],
  data: () => ({
    takenNumbers: new Set(),
    nextFree: null,
    originalIdentifier: null,
    loaded: false,
  }),
  computed: {
    rules() {
      return [
        (v) => !!v || this.$t("general.fieldNeedsToBeFilled"),
        (v) => this.isFree(v) || this.duplicateMessage,
      ];
    },
    duplicateMessage() {
      return this.$t("dangerousGoods.dangerousGoodsList.form.identifierTaken", {
        number: this.nextFree,
      });
    },
  },
  async created() {
    const mode = this.$route.params.mode;
    if (mode === "edit") this.originalIdentifier = this.value.identifier;

    const records = await this.$store.dispatch(
      "getClientDangerousGoodIdentifiers",
    );

    const ownId = this.$route.params.id;
    const numbers = new Set();
    for (const record of records || []) {
      if (mode === "edit" && String(record.id) === String(ownId)) continue;
      const text = String(record.identifier ?? "").trim();
      if (text) numbers.add(text.toLowerCase());
    }
    this.takenNumbers = numbers;
    this.nextFree = this.computeNextFree(records, ownId, mode);
    this.loaded = true;

    if ((mode === "new" || mode === "copy") && !this.value.identifier) {
      this.value.identifier = String(this.nextFree);
    }
  },
  methods: {
    isFree(v) {
      if (!this.loaded || !v) return true;
      const text = String(v).trim().toLowerCase();
      if (text === String(this.originalIdentifier ?? "").trim().toLowerCase()) {
        return true;
      }
      return !this.takenNumbers.has(text);
    },
    computeNextFree(records, ownId, mode) {
      const used = new Set();
      for (const record of records || []) {
        if (mode === "edit" && String(record.id) === String(ownId)) continue;
        const text = String(record.identifier ?? "").trim();
        if (/^\d+$/.test(text)) used.add(parseInt(text, 10));
      }
      let candidate = 1;
      while (used.has(candidate)) candidate += 1;
      return candidate;
    },
  },
};
</script>
